import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const grantFreeTrialCredits = {
  name: "grantFreeTrialCredits" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    success: z.boolean(),
    expirationDate: z.date(),
    creditsGranted: z.number(),
  }),
};
